export const SET_NOTIFICATION = "SET_NOTIFICATION";
export const MARK_AS_READ = "MARK_AS_READ";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";

const notificationAction = {};

notificationAction.setNotification = (payload) => {
  return {
    type: SET_NOTIFICATION,
    payload: {
      id: payload.id || Date.now() + Math.random(), // More unique ID
      title: payload.title || "Notification",
      description: payload.description || "",
      type: payload.type || "info",
      read: false,
      createdAt: new Date().toISOString(),
    },
  };
};

notificationAction.markAsRead = (id) => {
  return {
    type: MARK_AS_READ,
    payload: id,
  };
};

notificationAction.clearNotifications = () => {
  return {
    type: CLEAR_NOTIFICATIONS,
  };
};

export default notificationAction;